import Vue from 'vue2'
import VueRouter from 'vue2-router'
import { beforeEach, afterEach } from './interceptor'
import { addCollabRouter, propagateToMainGenerator } from '@/router/hooks'
import routes from './routes'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (to.path === from.path) return savedPosition
    return { x: 0, y: 0 }
  }
})

router.beforeResolve(beforeEach)
router.afterEach(afterEach)
// add collab router hook
window.addCollabRouter = addCollabRouter
window.propagateToMain = propagateToMainGenerator(router)

export default router
